// extracted by mini-css-extract-plugin
export default {"header":"Comments_header__74oWX font-sm-medium","commentSection":"Comments_commentSection__8SxTq font-sm-regular"};